// CreatorMenu.js
import React from 'react';
import dust from "../../../media/dust.svg"
import add from "../../../media/add.svg"
import select from "../../../media/select.svg"

const CreatorMenu2 = ({ onSelect, onAddToCollection, style }) => {
  return (
    <div className="creator-menu" style={style}>
      <div className="menu-option" onClick={onAddToCollection}>
        Remove
        <img src={dust} alt="" />
      </div>

      <div className="menu-option" onClick={onSelect}>
        Select
        <img src={select} alt="" />
      </div>
    </div>
  );
};

export default CreatorMenu2;
